import { actions } from '@app/action/ui';

export default function(state = {}, action) {
  const { type } = action;

  switch (type) {
    case actions.GET_SUBSCRIPTION_PRICING:
      return {
        ...state,
        subscriptionPricing: action.subscriptionPricing,
      };

    case actions.GET_SEATS_PRICING:
      return {
        ...state,
        seatsPricing: action.seatsPricing,
      };

    case actions.RESET_SUBSCRIPTION_PRICING:
      return {
        ...state,
        subscriptionPricing: null,
      };

    case actions.RESET_SEATS_PRICING:
      return {
        ...state,
        seatsPricing: null,
      };

    case actions.SET_ACTIVE_PAYMENT_METHOD:
      return {
        ...state,
        payment: {
          ...state.payment,
          activeMethod: action.method,
        },
      };

    case actions.SET_CREDIT_CARD_BRAND:
      return {
        ...state,
        payment: {
          ...state.payment,
          card: {
            ...state.payment.card,
            brand: action.brand,
          },
        },
      };

    case actions.SET_PAYMENT_METHOD_TO_COMPLETE:
      return {
        ...state,
        payment: {
          ...state.payment,
          [action.method]: {
            ...state.payment[action.method],
            complete: true,
          },
        },
      };

    case actions.RESET_PAYMENT_METHOD_TO_COMPLETE:
      return {
        ...state,
        payment: {
          ...state.payment,
          [action.method]: {
            ...state.payment[action.method],
            complete: false,
          },
        },
      };
  }

  return state;
}
